module.exports = __webpack_public_path__ + "static/media/U_dziala.d6ef6b0d.svg";